"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.billdel = billdel;
exports.del = del;
exports.getByMenuCode = getByMenuCode;
exports.getList = getList;
exports.getPrintTemplate = getPrintTemplate;
exports.update = update;
var _request = _interopRequireDefault(require("@/utils/request"));
var _cloud = require("@/utils/cloud");
// 分页
function getList(query) {
  return (0, _request.default)({
    url: _cloud.urls.jmreport + '/jimureport/print-template-config/list',
    method: 'POST',
    data: query
  });
}

// 查询
function getPrintTemplate(query) {
  return (0, _request.default)({
    url: _cloud.urls.jmreport + '/jimureport/print-template-config',
    method: 'get',
    params: query
  });
}

// 修改
function update(data) {
  return (0, _request.default)({
    url: _cloud.urls.jmreport + '/jimureport/print-template-config',
    method: 'put',
    data: data
  });
}

// 新增
function add(data) {
  return (0, _request.default)({
    url: _cloud.urls.jmreport + '/jimureport/print-template-config',
    method: 'post',
    data: data
  });
}

// 删除
function del(id) {
  return (0, _request.default)({
    url: _cloud.urls.jmreport + '/jimureport/print-template-config/del',
    method: 'delete',
    params: {
      id: id
    }
  });
}

// 根据菜单编号查询打印模板
function getByMenuCode(data) {
  return (0, _request.default)({
    url: _cloud.urls.jmreport + '/report/print-template/list',
    method: 'POST',
    data: data
  });
}

// 子表删除
function billdel(id) {
  return (0, _request.default)({
    url: _cloud.urls.jmreport + '/jimureport/print-template-entry/del',
    method: 'delete',
    params: {
      id: id
    }
  });
}